import { useSpotAndGreeks } from 'components/common-form/builder/form/node/field/SpotAndGreeksField/hooks';
import { useData } from 'components/common-form/hooks/useData';
import type { Underlying } from 'models/underlying';
import { FC } from 'react';
import type { GreeksTable } from 'state/quotes/details/details.model';

import type { ProductNodeBuilderProps } from '../../ProductNodeBuilder.model';
import { HorizontalSpotAndGreeksField } from './SpotAndGreeksField';

export const HorizontalSpotAndGreeks: FC<ProductNodeBuilderProps> = ({ node: { id }, tabIndex }) => {
  const [greeksEntry] = useData<GreeksTable>(id);
  const [underlyings] = useData<ReadonlyArray<Underlying>>('Underlyings', []);
  const spotAndGreeks = useSpotAndGreeks(greeksEntry, underlyings);

  return <HorizontalSpotAndGreeksField id={id} key={id} value={spotAndGreeks} tabIndex={tabIndex} />;
};
HorizontalSpotAndGreeks.displayName = 'HorizontalSpotAndGreeks';
